import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
// 从vue.config.js中直接获取配置的值
// const config = require('../../../vue.config.js')
// const projectname = config.devServer.overlay.projectname
var projectname = process.env.VUE_APP_PROJECT_NAME; // const constantRouterMap = require('@/router/' + projectname)
// const constantRouterMap = require('@/router')

import { constantRouterMap } from '@/router'; // import { constantRouterMap } from ('@/router/' + projectname)
// if (process.env.NODE_ENV != 'development') {
//   constantRouterMap = require('@/router' + projectname)
// }

var _import = require('../../router/_import_' + process.env.NODE_ENV);

var enterRouterS = {
  PMS: {
    path: '/',
    component: FullScreenLayout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      name: 'Index',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/dashboard/admin/index'));
        });
      },
      meta: {
        title: '小区态势',
        icon: 'dashboard',
        noCache: true
      },
      hidden: true
    }]
  },
  SLXC: {
    path: '/',
    component: Layout,
    redirect: {
      name: 'dashboard'
    },
    children: [{
      path: 'navigation',
      name: 'dashboard',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/dashboard/index'));
        });
      },
      meta: {
        title: '首页',
        icon: 'dashboard',
        noCache: true
      },
      hidden: true
    }]
  }
};
import Layout from '../../layout/index'; // import energyLayout from '../../views/layout/energyLayout'

import store from '@/store';
import FullScreenLayout from '../../views/layout/FullScreenLayout';
var permission = {
  state: {
    routers: constantRouterMap,
    adminRouters: [],
    // 后端生成的菜单
    choosenRouters: [],
    // 被选中的左侧菜单
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: function SET_ROUTERS(state, routers) {
      state.addRouters = routers;
      state.adminRouters = routers;
      state.routers = constantRouterMap.concat(routers); // 如果一开始没有被选中，则指定第一个选中

      if (state.choosenRouters === null || state.choosenRouters && state.choosenRouters.length < 1) {
        state.choosenRouters = routers[0];
      }
    },
    CHOOSE_ROUTERS: function CHOOSE_ROUTERS(state, routers) {
      // 修改选中的左侧菜单
      state.choosenRouters = routers;
    },
    RESET_ROUTERS: function RESET_ROUTERS(state, routers) {
      // 重置菜单（退出登录后重置）
      state = {
        routers: constantRouterMap,
        choosenRouters: [],
        // 被选中的左侧菜单
        addRouters: []
      };
    }
  },
  actions: {
    GenerateRoutes: function GenerateRoutes(_ref, data) {
      var commit = _ref.commit;
      return new Promise(function (resolve) {
        var menuTree = data;
        var accessedRouters = [];
        menuTreeFormat(menuTree);

        if (store.state.user.userType === 1 || store.state.user.userType === 3 || store.state.user.userType === 4) {
          // 可以进入小区首页
          // 多入口修改：此处允许配置多个首页应对不同入口。
          menuTree.unshift(enterRouterS[projectname]);
        } else {
          menuTree.unshift({
            path: '/',
            component: FullScreenLayout,
            redirect: '/dashboard',
            children: [{
              path: 'dashboard',
              name: 'Index',
              component: function component() {
                return Promise.resolve().then(function () {
                  return _interopRequireWildcard(require('@/views/dashboard/zhlg/index'));
                });
              },
              meta: {
                title: '小区态势',
                icon: 'dashboard',
                noCache: true
              },
              hidden: true
            }]
          });
        }

        menuTree.push({
          path: '*',
          redirect: '/404',
          hidden: true
        });
        accessedRouters = menuTree;
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      });
    },
    ChooseRouters: function ChooseRouters(_ref2, routers) {
      var commit = _ref2.commit,
          state = _ref2.state;
      // 修改选中的左侧菜单
      console.log('修改左侧菜单');
      console.log(routers);
      return new Promise(function (resolve) {
        commit('CHOOSE_ROUTERS', routers);
        console.log(state.choosenRouters);
        resolve();
      });
    },
    ResetRouters: function ResetRouters(_ref3, routers) {
      var commit = _ref3.commit,
          state = _ref3.state;
      // 修改选中的左侧菜单
      console.log('重置菜单');
      return new Promise(function (resolve) {
        commit('RESET_ROUTERS', routers);
        resolve();
      });
    }
  }
};

function menuFormat(e) {
  if (e.componentType === 'layout' && e.menuUpId === 0) {
    e.component = Layout;
  } else {
    if (e.componentType === 'url') {
      // 对数据进行截断，并重新赋值
      var str = e.path.split('?')[1];
      var query = {};

      if (str !== undefined && str !== '') {
        var queryList = str.split('&');
        queryList.forEach(function (item) {
          var list = item.split('=');
          query[list[0]] = list[1];
        });
        e.props = {
          query: query
        };
        e.path = e.path.split('?')[0];
      } // 兼容处理：如果组件路径为空或无效，使用占位组件


      if (e.component && e.component.trim()) {
        e.component = _import(
        /* webpackChunkName: "menu" */
        e.component);
      } else {
        console.warn("[\u83DC\u5355\u8B66\u544A] \u83DC\u5355 \"".concat(e.name || e.path, "\" \u7684\u7EC4\u4EF6\u8DEF\u5F84\u4E3A\u7A7A\uFF0C\u4F7F\u7528\u5360\u4F4D\u9875\u9762"));
        e.component = _import('common/NotFound');
      }
    }

    if (e.componentType === 'layout') {
      // 次级菜单
      // 兼容处理：如果组件路径为空或无效，使用占位组件
      if (e.component && e.component.trim()) {
        e.component = _import(
        /* webpackChunkName: "layout" */
        e.component);
      } else {
        console.warn("[\u83DC\u5355\u8B66\u544A] \u83DC\u5355 \"".concat(e.name || e.path, "\" \u7684\u7EC4\u4EF6\u8DEF\u5F84\u4E3A\u7A7A\uFF0C\u4F7F\u7528\u5360\u4F4D\u9875\u9762"));
        e.component = _import('common/NotFound');
      }
    }
  }
}

function menuTreeFormat(menuTree) {
  if (menuTree.length > 0) {
    menuTree.forEach(function (e) {
      menuFormat(e);

      if (e.children != null && e.children.length > 0) {
        menuTreeFormat(e.children);
      }
    });
  }
}

export default permission;